module.exports = __webpack_public_path__ + "img/user.ec6ae432.png";